import { SearchQueryRequestType } from '../../common/types';
import { usePostFetch } from '../../utils/reactQuery';
import { pathToUrl } from '../../utils/router';
import { ApiRoutesEnum } from '../../utils/routes';

import { RecruitmentType } from './Recruitments.types';

export type FetchRecruitmentsResponseType = {
  count: number;
  results: RecruitmentType[];
};

export const useSearchRecruitments = (payload: SearchQueryRequestType) =>
  usePostFetch<FetchRecruitmentsResponseType>(pathToUrl(ApiRoutesEnum.searchRecruitments), payload);
